import { render } from "./BarGraphPlot.vue?vue&type=template&id=422236a0"
import script from "./BarGraphPlot.vue?vue&type=script&lang=js"
export * from "./BarGraphPlot.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__